/**
 * Responsive Layout Component
 * Primary layout wrapper that handles responsive breakpoints and layout transformations
 */

import React from 'react'
import { Outlet } from 'react-router-dom'
import { useMediaQuery } from '../../utils/responsiveUtils'
import ResponsiveNavigation from '../navigation/ResponsiveNavigation'
import ResponsiveSidebar from './ResponsiveSidebar'

export interface ResponsiveLayoutProps {
  children?: React.ReactNode
  showSidebar?: boolean
  sidebarContent?: React.ReactNode
  onLogout?: () => void
}

export const ResponsiveLayout: React.FC<ResponsiveLayoutProps> = ({
  children,
  showSidebar = true,
  sidebarContent,
  onLogout,
}) => {
  const isMobile = useMediaQuery('(max-width: 767px)')
  const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 1023px)')
  const isDesktop = useMediaQuery('(min-width: 1024px)')

  const getLayoutClass = () => {
    if (isMobile) return 'mobile-layout'
    if (isTablet) return 'tablet-layout'
    return 'desktop-layout'
  }

  return (
    <div className={`responsive-layout min-h-screen   ${getLayoutClass()}`}>
      {/* Responsive Navigation */}
      <ResponsiveNavigation onLogout={onLogout} className="responsive-nav" />

      {/* Main Layout Container */}
      <div className="layout-container bg-tdplbisque">
        {/* Desktop: Persistent Sidebar */}
        {isDesktop && showSidebar && (
          <aside className="desktop-sidebar">
            <ResponsiveSidebar
              content={sidebarContent}
              isOpen={true}
              onClose={() => {}}
              variant="desktop"
            />
          </aside>
        )}

        {/* Main Content Area */}
        <main className="main-content">
          <div className="content-wrapper">{children || <Outlet />}</div>
        </main>
      </div>
    </div>
  )
}

export default ResponsiveLayout
